export const fetchEdges = async (authFetch, options) => {
  const response = await authFetch(process.env.REACT_APP_CONN, options);
  return response.json();
};
